/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  MonitoringPerfPerformanceCSVProtocolsGetAssetAnalysisCsvRequest,
  MonitoringPerfPerformanceCSVProtocolsGetCohortAnalysisCSVRequest,
  MonitoringPerfPerformanceCSVProtocolsGetCountryAnalysisCsvRequest,
  MonitoringPerfPerformanceCSVProtocolsGetMarketplaceAnalysisCsvRequest,
  MonitoringPerfPerformanceCSVProtocolsGetOverviewCsvRequest,
  MonitoringPerfPerformanceCSVProtocolsGetSellerAnalysisCsvRequest,
  MonitoringPerfPerformanceCSVProtocolsGetStatusAnalysisCsvRequest,
  MonitoringPerfPerformanceProtocolsAddPerformanceMetricTabRequest,
  MonitoringPerfPerformanceProtocolsCopyFilterToCustomTabRequest,
  MonitoringPerfPerformanceProtocolsDeleteFilterFromTabRequest,
  MonitoringPerfPerformanceProtocolsDeletePerformanceMetricTabRequest,
  MonitoringPerfPerformanceProtocolsEditPerformanceMetricTabRequest,
  MonitoringPerfPerformanceProtocolsGetAllPerformanceMetricTabsResponse,
  MonitoringPerfPerformanceProtocolsGetAllSectionsForTabRequest,
  MonitoringPerfPerformanceProtocolsGetAllSectionsForTabResponse,
  MonitoringPerfPerformanceProtocolsGetAllSectionsWithDataForTabRequest,
  MonitoringPerfPerformanceProtocolsGetAllSectionsWithDataForTabResponse,
  MonitoringPerfPerformanceProtocolsGetAssetAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetAssetAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetClientCountryListResponse,
  MonitoringPerfPerformanceProtocolsGetCohortAnalysisCSVNewRequest,
  MonitoringPerfPerformanceProtocolsGetCohortAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetCohortAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetCohortAnalysisRequest,
  MonitoringPerfPerformanceProtocolsGetCohortAnalysisResponse,
  MonitoringPerfPerformanceProtocolsGetCohortFilterNewRequest,
  MonitoringPerfPerformanceProtocolsGetCohortFilterNewResponse,
  MonitoringPerfPerformanceProtocolsGetCohortFilterRequest,
  MonitoringPerfPerformanceProtocolsGetCohortFilterResponse,
  MonitoringPerfPerformanceProtocolsGetComplianceRateRequest,
  MonitoringPerfPerformanceProtocolsGetComplianceRateResponse,
  MonitoringPerfPerformanceProtocolsGetComplianceRateTopMarketsRequest,
  MonitoringPerfPerformanceProtocolsGetComplianceRateTopMarketsResponse,
  MonitoringPerfPerformanceProtocolsGetCountryAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetCountryAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetEcommerceCountsRequest,
  MonitoringPerfPerformanceProtocolsGetEcommerceCountsResponse,
  MonitoringPerfPerformanceProtocolsGetEnforcedValueRequest,
  MonitoringPerfPerformanceProtocolsGetEnforcedValueResponse,
  MonitoringPerfPerformanceProtocolsGetExpertServicesRequest,
  MonitoringPerfPerformanceProtocolsGetExpertServicesResponse,
  MonitoringPerfPerformanceProtocolsGetImpactedSellerRequest,
  MonitoringPerfPerformanceProtocolsGetImpactedSellerResponse,
  MonitoringPerfPerformanceProtocolsGetMarketplaceAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetMarketplaceAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetOverviewDataRequest,
  MonitoringPerfPerformanceProtocolsGetOverviewDataResponse,
  MonitoringPerfPerformanceProtocolsGetRemovedListingsOverTimeRequest,
  MonitoringPerfPerformanceProtocolsGetRemovedListingsOverTimeResponse,
  MonitoringPerfPerformanceProtocolsGetSectionInfoRequest,
  MonitoringPerfPerformanceProtocolsGetSectionInfoResponse,
  MonitoringPerfPerformanceProtocolsGetSellerAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetSellerAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetStatusAnalysisDataRequest,
  MonitoringPerfPerformanceProtocolsGetStatusAnalysisDataResponse,
  MonitoringPerfPerformanceProtocolsGetTopInfringingSellersRequest,
  MonitoringPerfPerformanceProtocolsGetTopInfringingSellersResponse,
  MonitoringPerfPerformanceProtocolsGetWebsiteCountsRequest,
  MonitoringPerfPerformanceProtocolsGetWebsiteCountsResponse,
  MonitoringPerfPerformanceProtocolsReorderComponentRequest,
  MonitoringPerfPerformanceProtocolsSaveFilterToTabRequest,
  MonitoringPerfPerformanceReportProtocolsGetListRequest,
  MonitoringPerfPerformanceReportProtocolsGetListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Performance<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Performance
   * @name GetAllTabsList
   * @request GET:/performance/get_all_tabs
   */
  getAllTabsList = (params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetAllPerformanceMetricTabsResponse, any>({
      path: `/performance/get_all_tabs`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAllSectionsForTabCreate
   * @request POST:/performance/get_all_sections_for_tab
   */
  getAllSectionsForTabCreate = (
    data: MonitoringPerfPerformanceProtocolsGetAllSectionsForTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetAllSectionsForTabResponse, any>({
      path: `/performance/get_all_sections_for_tab`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name EcommerceCountsCreate
   * @request POST:/performance/ecommerce-counts
   */
  ecommerceCountsCreate = (
    data: MonitoringPerfPerformanceProtocolsGetEcommerceCountsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetEcommerceCountsResponse, any>({
      path: `/performance/ecommerce-counts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CountryListList
   * @request GET:/performance/country-list
   */
  countryListList = (params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetClientCountryListResponse, any>({
      path: `/performance/country-list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name WebsiteCountsCreate
   * @request POST:/performance/website-counts
   */
  websiteCountsCreate = (data: MonitoringPerfPerformanceProtocolsGetWebsiteCountsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetWebsiteCountsResponse, any>({
      path: `/performance/website-counts`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name EnforcedValueCreate
   * @request POST:/performance/enforced-value
   */
  enforcedValueCreate = (data: MonitoringPerfPerformanceProtocolsGetEnforcedValueRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetEnforcedValueResponse, any>({
      path: `/performance/enforced-value`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ImpactedSellerCreate
   * @request POST:/performance/impacted-seller
   */
  impactedSellerCreate = (
    data: MonitoringPerfPerformanceProtocolsGetImpactedSellerRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetImpactedSellerResponse, any>({
      path: `/performance/impacted-seller`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateCreate
   * @request POST:/performance/compliance-rate
   */
  complianceRateCreate = (
    data: MonitoringPerfPerformanceProtocolsGetComplianceRateRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetComplianceRateResponse, any>({
      path: `/performance/compliance-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ExpertServicesCreate
   * @request POST:/performance/expert-services
   */
  expertServicesCreate = (
    data: MonitoringPerfPerformanceProtocolsGetExpertServicesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetExpertServicesResponse, any>({
      path: `/performance/expert-services`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisCsvCreate
   * @request POST:/performance/cohort-analysis-csv
   */
  cohortAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceProtocolsGetCohortAnalysisCSVNewRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/cohort-analysis-csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAllSectionsWithDataForTabCreate
   * @request POST:/performance/get_all_sections_with_data_for_tab
   */
  getAllSectionsWithDataForTabCreate = (
    data: MonitoringPerfPerformanceProtocolsGetAllSectionsWithDataForTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetAllSectionsWithDataForTabResponse, any>({
      path: `/performance/get_all_sections_with_data_for_tab`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetSectionInfoCreate
   * @request POST:/performance/get_section_info
   */
  getSectionInfoCreate = (data: MonitoringPerfPerformanceProtocolsGetSectionInfoRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetSectionInfoResponse, any>({
      path: `/performance/get_section_info`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetOverviewDataCreate
   * @request POST:/performance/get_overview_data
   */
  getOverviewDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetOverviewDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetOverviewDataResponse, any>({
      path: `/performance/get_overview_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetStatusAnalysisDataCreate
   * @request POST:/performance/get_status_analysis_data
   */
  getStatusAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetStatusAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetStatusAnalysisDataResponse, any>({
      path: `/performance/get_status_analysis_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetMarketplaceAnalysisDataCreate
   * @request POST:/performance/get_marketplace_analysis_data
   */
  getMarketplaceAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetMarketplaceAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetMarketplaceAnalysisDataResponse, any>({
      path: `/performance/get_marketplace_analysis_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetCountryAnalysisDataCreate
   * @request POST:/performance/get_country_analysis_data
   */
  getCountryAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetCountryAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetCountryAnalysisDataResponse, any>({
      path: `/performance/get_country_analysis_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAssetAnalysisDataCreate
   * @request POST:/performance/get_asset_analysis_data
   */
  getAssetAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetAssetAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetAssetAnalysisDataResponse, any>({
      path: `/performance/get_asset_analysis_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetSellerAnalysisDataCreate
   * @request POST:/performance/get_seller_analysis_data
   */
  getSellerAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetSellerAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetSellerAnalysisDataResponse, any>({
      path: `/performance/get_seller_analysis_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisDataCreate
   * @request POST:/performance/cohort_analysis/data
   */
  cohortAnalysisDataCreate = (
    data: MonitoringPerfPerformanceProtocolsGetCohortAnalysisDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetCohortAnalysisDataResponse, any>({
      path: `/performance/cohort_analysis/data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisFilterCreate
   * @request POST:/performance/cohort_analysis/filter
   */
  cohortAnalysisFilterCreate = (
    data: MonitoringPerfPerformanceProtocolsGetCohortFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetCohortFilterResponse, any>({
      path: `/performance/cohort_analysis/filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisFilterCreate2
   * @request POST:/performance/cohort-analysis/filter
   * @originalName cohortAnalysisFilterCreate
   * @duplicate
   */
  cohortAnalysisFilterCreate2 = (
    data: MonitoringPerfPerformanceProtocolsGetCohortFilterNewRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetCohortFilterNewResponse, any>({
      path: `/performance/cohort-analysis/filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name TopInfringingSellersCreate
   * @request POST:/performance/top-infringing-sellers
   */
  topInfringingSellersCreate = (
    data: MonitoringPerfPerformanceProtocolsGetTopInfringingSellersRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetTopInfringingSellersResponse, any>({
      path: `/performance/top-infringing-sellers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ListingsTimeCreate
   * @request POST:/performance/listings-time
   */
  listingsTimeCreate = (
    data: MonitoringPerfPerformanceProtocolsGetRemovedListingsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetRemovedListingsOverTimeResponse, any>({
      path: `/performance/listings-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateTopCreate
   * @request POST:/performance/compliance-rate-top
   */
  complianceRateTopCreate = (
    data: MonitoringPerfPerformanceProtocolsGetComplianceRateTopMarketsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetComplianceRateTopMarketsResponse, any>({
      path: `/performance/compliance-rate-top`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CohortAnalysisCreate
   * @request POST:/performance/cohort-analysis
   */
  cohortAnalysisCreate = (
    data: MonitoringPerfPerformanceProtocolsGetCohortAnalysisRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPerfPerformanceProtocolsGetCohortAnalysisResponse, any>({
      path: `/performance/cohort-analysis`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name CopySectionCreate
   * @request POST:/performance/copy_section
   */
  copySectionCreate = (
    data: MonitoringPerfPerformanceProtocolsCopyFilterToCustomTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/copy_section`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name SaveSectionCreate
   * @request POST:/performance/save_section
   */
  saveSectionCreate = (data: MonitoringPerfPerformanceProtocolsSaveFilterToTabRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/performance/save_section`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DeleteSectionCreate
   * @request POST:/performance/delete_section
   */
  deleteSectionCreate = (
    data: MonitoringPerfPerformanceProtocolsDeleteFilterFromTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/delete_section`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ReorderSectionCreate
   * @request POST:/performance/reorder_section
   */
  reorderSectionCreate = (
    data: MonitoringPerfPerformanceProtocolsReorderComponentRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/reorder_section`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name AddMetricTabCreate
   * @request POST:/performance/add_metric_tab
   */
  addMetricTabCreate = (
    data: MonitoringPerfPerformanceProtocolsAddPerformanceMetricTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/add_metric_tab`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name EditMetricTabCreate
   * @request POST:/performance/edit_metric_tab
   */
  editMetricTabCreate = (
    data: MonitoringPerfPerformanceProtocolsEditPerformanceMetricTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/edit_metric_tab`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DeleteMetricTabCreate
   * @request POST:/performance/delete_metric_tab
   */
  deleteMetricTabCreate = (
    data: MonitoringPerfPerformanceProtocolsDeletePerformanceMetricTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/performance/delete_metric_tab`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetOverviewCsvCreate
   * @request POST:/performance/get_overview_csv
   */
  getOverviewCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetOverviewCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_overview_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetStatusAnalysisCsvCreate
   * @request POST:/performance/get_status_analysis_csv
   */
  getStatusAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetStatusAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_status_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetMarketplaceAnalysisCsvCreate
   * @request POST:/performance/get_marketplace_analysis_csv
   */
  getMarketplaceAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetMarketplaceAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_marketplace_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetCountryAnalysisCsvCreate
   * @request POST:/performance/get_country_analysis_csv
   */
  getCountryAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetCountryAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_country_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAssetAnalysisCsvCreate
   * @request POST:/performance/get_asset_analysis_csv
   */
  getAssetAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetAssetAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_asset_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetSellerAnalysisCsvCreate
   * @request POST:/performance/get_seller_analysis_csv
   */
  getSellerAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetSellerAnalysisCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_seller_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetCohortAnalysisCsvCreate
   * @request POST:/performance/get_cohort_analysis_csv
   */
  getCohortAnalysisCsvCreate = (
    data: MonitoringPerfPerformanceCSVProtocolsGetCohortAnalysisCSVRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/get_cohort_analysis_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ReportListCreate
   * @request POST:/performance/report/list
   */
  reportListCreate = (data: MonitoringPerfPerformanceReportProtocolsGetListRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringPerfPerformanceReportProtocolsGetListResponse, any>({
      path: `/performance/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
